/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Core
import PropTypes from "prop-types";

// Components
import BoxV1 from "components/Atoms/Box/BoxV1";
import Select from "components/Atoms/Select";
import TypographyV1 from "components/Atoms/Typography/TypographyV1";

function SelectDefault({
  label,
  defaultValue,
  onChange,
  options,
  isDisabled,
  fieldType,
  name,
  mt,
  mb,
  ml,
  mr,
  componentWidth,
  ...rest
}) {
  const controlledProps =
    fieldType && Object.prototype.hasOwnProperty.call(fieldType, "value")
      ? { value: options.find((o) => o.value === fieldType.value) || null }
      : { defaultValue };

  const selectEl = (
    <Select
      {...fieldType}
      {...controlledProps}
      onChange={onChange}
      options={options}
      isDisabled={isDisabled}
      name={name}
      {...rest}
    />
  );

  return label !== " " ? (
    <BoxV1 mb={mb} mt={mt} ml={ml} mr={mr} width={componentWidth}>
      <BoxV1 mb={1} ml={0.5} lineHeight={0} display="inline-block">
        <TypographyV1
          component="label"
          variant="caption"
          fontWeight="bold"
          textTransform="capitalize"
        >
          {label}
        </TypographyV1>
      </BoxV1>
      {selectEl}
    </BoxV1>
  ) : (
    selectEl
  );
}

// Setting default values for the props of FormField
SelectDefault.defaultProps = {
  label: " ",
  onChange: () => {},
  options: [],
  isDisabled: false,
  defaultValue: { value: "", label: "" },
  fieldType: {},
  name: "",
  mt: 0,
  mb: 0,
  ml: 0,
  mr: 0,
  componentWidth: "inherit",
};

// Typechecking props for FormField
SelectDefault.propTypes = {
  label: PropTypes.string,
  defaultValue: PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
  onChange: PropTypes.func,
  // eslint-disable-next-line
  options: PropTypes.arrayOf(PropTypes.object),
  isDisabled: PropTypes.bool,
  fieldType: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
  }),
  name: PropTypes.string,
  mt: PropTypes.number,
  mb: PropTypes.number,
  ml: PropTypes.number,
  mr: PropTypes.number,
  componentWidth: PropTypes.string,
};

export default SelectDefault;
